import React from "react";
import AdditionalCompliances from "./AdditionalCompliances";

const AUDIT_TYPES = ["Audit", "Liquidation", "Undertaking Letter", "Special Purpose", "SRTIP", "Others"];

export default function AuditAndOtherCompliance() {
  return <AdditionalCompliances moduleTitle="Audit and Other Compliance" moduleTypes={AUDIT_TYPES} />;
}
